/**
 * Antalsvaelgeren paa produktkortet (snippets/jkl-product-card.liquid).
 *
 * Kortet har to tal for det samme: det synlige i .qty-value og det skjulte
 * input.pdp-qty-value, der faktisk sendes med formularen. De to ligger i hver
 * sin container, fordi vaelgeren ikke kan staa inde i <form> uden at knapperne
 * submitter den — saa de skal holdes i sync herfra.
 *
 * Delegeret paa document frem for bundet pr. kort: PLP'en skifter kortene ud
 * ved live-filtrering og haenger flere paa ved uendelig scroll, og en delegeret
 * lytter daekker de nye kort uden at skulle bindes forfra.
 *
 * Samme adfaerd som PDP'ens vaelger: skridt paa 1, aldrig under 1.
 */
(function () {
  var MIN = 1;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;

    var selector = button.closest('[data-card-quantity]');
    if (!selector) return;

    // Vaelgeren og formularen er soskende inde i .actions.
    var scope = selector.closest('.actions') || selector.parentNode;
    var display = selector.querySelector('[data-qty-value]');
    var input = scope.querySelector('.pdp-qty-value');
    if (!display) return;

    // Det skjulte input er kilden naar det findes; ellers det viste tal.
    var current = parseInt((input && input.value) || display.textContent, 10);
    if (isNaN(current)) current = MIN;

    var next = current + parseInt(button.dataset.qtyStep, 10);
    if (next < MIN) next = MIN;

    display.textContent = next;
    if (input) input.value = next;
  });
})();
